import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import _ from 'lodash'

import styles from './styles'

export default ({
  title,
  icon,
  paths,
  currentPath,
}) => {
  const classes = styles()

  const userPermission = useSelector(state => state.user.permission)

  const validatePermission = (route) => {
    if (!_.isFunction(route.FUNC_PERMISSION)) return true

    return route.FUNC_PERMISSION(userPermission)
  }

  const renderTab = (name, path) => {
    return (
      <li key={path}>
        <Link
          className={(currentPath === path) ? classes.selected : ''}
          to={path}
        >
          {name}
        </Link>
      </li>
    )
  }

  const renderTabs = () => {
    return _.chain(paths)
            .values()
            .filter(validatePermission)
            .map(route => renderTab(route.NAME, route.PATH))
            .value()
  }

  const renderNavDocs = () => {
    const elemTabs = renderTabs()
    if (_.isEmpty(elemTabs)) return null

    return (
      <li>
        <div className={classes.category}>
          <div className={classes.iconContainer}>{icon}</div>
          {title}
        </div>

        <ul>
          {elemTabs}
        </ul>
      </li>
    )
  }

  return (
    <nav>
      <ul>
        {renderNavDocs()}
      </ul>
    </nav>
  )
}
